<template>
  <div class="page final">
	  <h1>Merci pour <br> votre visite !</h1>
    <borne-header></borne-header>

    <p>Un projet réalisé en collaboration avec</p>
    <div class="images">
      <img src="@/assets/logo_inrap.jpg" alt="Inrap: Institut national de recherches archéologiques préventives"/>
      <img src="@/assets/logo_grepam.jpg" alt="GREPAM"/>
    </div>

    <p>Un projet financé par </p>
    <div class="images">
      <img src="@/assets/logo3.png" alt="L'agglo Herault Mediterrannee"/>
    </div>
        <div class="images">
      <img src="@/assets/logo_eu.jpg" alt="Europe"/>
    </div>

    <div class="cta">
      <router-link class="buttonLink" to="/" >Quitter</router-link>
    </div>
  </div>
</template>

<script>

import BorneHeader from "../components/BorneHeader"

export default {
  name: 'home',
  components: {BorneHeader},
  data: () => ({
  }),
  methods: {
  }
}
</script>



<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.page.final {
  .boisRiquet {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    margin-bottom: 10px;
  }
  p {
    margin-bottom: 0px;
  }
  h1 {
    font-family: 'Yeseva One', sans-serif;
    font-weight: lighter;
  }
  .agglo{
    width:200px;
    height:200px;
    display: flex;
    justify-content: center;
    margin-bottom: 20%;
  }
  .images {
    display: flex;
    flex-direction: column;
    width: 100%;
    justify-content: center;
    margin-bottom: 0px;

    img {
      height: 75px;
      object-fit: contain;
    }
  }
  .borneheader{
    display: flex;
    justify-content: center;
    margin-top: 30px;
    margin-right: 0px;
    margin-bottom: 30px;
  }
  .BorneHeader{
    display: flex;
    justify-content: center;
  }
  .cta {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }

  @media screen and (min-width: 500px) { 
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

}
</style>



// WEBPACK FOOTER //
// src/views/LastPanel.vue